import React from "react";
import styles from './Accordion.styl'

class Panel extends React.Component {
	constructor(props) {
		super(props);

	}


	render () {
		const { label, content, activeTab, index, activateTab } = this.props;
		const isActive = activeTab === index;
		const innerStyle = {
			height:  isActive ? '100%'  : '0px'
		}

		return (
			<div className={styles.panel}
					 role='tabpanel'
					 aria-expanded={ isActive }>
				<button className={styles.panel__label}
								role='tab'
								onClick={ activateTab }>
					{ label }
				</button>
				<div className={styles.panel__inner}
						 style={ innerStyle }
						 aria-hidden={ !isActive }>
					<div className={styles.panel__content}>
						{content.map((i,id)=>{
						return(<div className={styles.cfgList} key={id+'list'}>
						<span>{i.name}</span> <span style={{textAlign:'end',borderLeft:'none'}}>{i.selected}</span>
						</div>)
					})}
					</div>
				</div>
			</div>
		);
	}
}


class Accordion extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// const { activeTab } = this.state;
		const {panels,activeTab}=this.props
		return (
			<div className={styles.accordion} role='tablist'>
				{panels.map((panel, index) =>
					<Panel
						key={ index }
						activeTab={ activeTab }
						index={ index }
						{ ...panel }
						activateTab={ this.props.activateTab.bind(null, index) }
					/>
				)}
			</div>
		);
	}
}


export default Accordion;



// WEBPACK FOOTER //
// ./src/react/ui/features/Accordion.jsx